var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 13.3996C5.73418 13.3996 4.4968 13.0243 3.44433 12.321C2.39185 11.6178 1.57155 10.6182 1.08715 9.44878C0.602749 8.27934 0.476007 6.99251 0.722953 5.75103C0.969898 4.50955 1.57944 3.36918 2.47449 2.47413C3.36955 1.57907 4.50992 0.969532 5.7514 0.722586C6.99288 0.475641 8.2797 0.602382 9.44915 1.08678C10.6186 1.57118 11.6181 2.39149 12.3214 3.44396C13.0246 4.49644 13.4 5.73381 13.4 6.99961C13.398 8.69639 12.7231 10.3231 11.5233 11.5229C10.3235 12.7227 8.69676 13.3976 6.99998 13.3996ZM6.99998 3.50841C6.8457 3.50841 6.69772 3.56962 6.58853 3.67861C6.47934 3.78761 6.41786 3.93547 6.41758 4.08974V7.58201C6.41786 7.73629 6.47934 7.88415 6.58853 7.99314C6.69772 8.10213 6.8457 8.16334 6.99998 8.16334H9.90878C10.0631 8.16334 10.2111 8.10204 10.3202 7.99292C10.4293 7.8838 10.4906 7.7358 10.4906 7.58148C10.4906 7.42716 10.4293 7.27916 10.3202 7.17004C10.2111 7.06091 10.0631 6.99961 9.90878 6.99961H7.58238V4.08974C7.58209 3.93547 7.52061 3.78761 7.41142 3.67861C7.30223 3.56962 7.15425 3.50841 6.99998 3.50841Z",
    fill: "#C0C0CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockFilled);
export default __webpack_public_path__ + "static/media/clock-filled.94d37d12579dc80d1a43662c999d09a0.svg";
export { ForwardRef as ReactComponent };